import { Component,ViewChild,Renderer2 } from "@angular/core";
import { Router } from '@angular/router';
import { QuizService } from '../../Service/Quizservice';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from "Config/config";
import  'rxjs/add/operator/map';
import { Chart } from 'chart.js';
import { PlatformLocation } from "@angular/common";
import { HostListener } from '@angular/core';
declare var gtag: Function;

@Component({
  selector: "home-page",
  templateUrl: "./home.page.html", styleUrls: ["../app.component.css"]
})
export class HomePage {
  teachername;
  gtmId;
  quizcount;
  Published;
  canvas: any;
  ctx: any;
  @ViewChild('mychart') mychart;
  constructor(public router: Router, private QuizService: QuizService, private http: HttpClient,private _config: Config,location: PlatformLocation,private renderer:Renderer2) {
    
    this.getconfigkey().subscribe(data=>{
      //this.url=data['url'];
      this.gtmId=data['gtmId'];
    })

  }
  public getconfigkey():any{   
         
    return this.http.get("assets/env.json");            
    }


  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    console.log('Back button pressed');
    window.history.forward();
    this.router.navigate(["/home"]);
  }
  ngOnInit() {
    const script = this.renderer.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id='+this.gtmId;
  
    // Add an onload event to ensure the script is loaded before using gtag
    script.onload = () => {
      this.initGtag();
    };
  
    // Append the script to the head section of the document
    this.renderer.appendChild(document.head, script);
    this.teachername = sessionStorage.getItem('teachername');
    this.quizcount = sessionStorage.getItem('Quizcount');
    this.Published = sessionStorage.getItem('Published');
    if (this.teachername == undefined) {
      this.logout();
    }
    var date = new Date();
    date.setDate(date.getDate() - 30);
    var jsonobj1 = [
      {
        "createdby": sessionStorage.getItem("Td"),
        "ispublished":1,
      }];
      this.QuizService.getQuizcount(jsonobj1).subscribe(data => {
        this.Published = data["Count"];
        sessionStorage.setItem('Published', this.Published);
      });
     
    var jsonobj = [
      {
        "createdby": sessionStorage.getItem("Td")
      }];
      this.QuizService.getQuizcount(jsonobj).subscribe(data => {
        this.quizcount = data["Count"];
        sessionStorage.setItem('Quizcount', this.quizcount);
      });
    document.getElementById("btnGroupDrop1").innerText = this.teachername;
   
  }
 
  private initGtag() {
    // Add the Google Tag Manager script
    const gTagScript = this.renderer.createElement('script');
    gTagScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    `;
  
    // Append the GTM script to the head section of the document
    this.renderer.appendChild(document.head, gTagScript);
  
    let users;
    let roles;
  
    if (this.teachername) {
      users = this.teachername;
      roles = "Teacher";
    } else {
      users = sessionStorage.getItem('studname');
      roles = "Student";
    }
  
    console.log("User initgtg:", users);
    console.log("Role:", roles);
  
    // Now you can safely use the gtag function
    gtag('event', 'user_details', { 'UserName': users, 'UserType': roles });
  
    // Rest of your ngOnInit() code...
  }
  logout() {
    this.router.navigate(["/"]);
    sessionStorage.clear();
  }
  send() {
    const headers = new HttpHeaders()
      .set('Authorization', 'my-auth-token')
      .set('Content-Type', 'application/json');
    return this.http.post("http://10.10.13.40:8081/upload", {
      headers: headers
    });
  }
  ngAfterViewInit() {
    this.canvas = this.mychart.nativeElement; 
    this.ctx = this.canvas.getContext('2d');

    let myChart = new Chart(this.ctx, {
      type: 'line',
      
      data: {
        datasets: [{
          label: 'Contour line',
          backgroundColor: "rgba(255, 99, 132,0.4)",
          borderColor: "rgb(255, 99, 132)",
          fill: true,
          data: [
            { x: 1, y: 2 },
            { x: 2500, y: 2.5 },
            { x: 3000, y: 5 },
            { x: 3400, y: 4.75 },
            { x: 3600, y: 4.75 },
            { x: 5200, y: 6 },
            { x: 6000, y: 9 },
            { x: 7100, y: 6 },
          ],
        }]
      },
      options: {
        responsive: true,
        title: {
          display: true,
          text: 'Contour line'
        },
        scales: {
          xAxes: [{
            type: 'linear',
            position: 'bottom',
            ticks: {
              
            },
            scaleLabel: {
              labelString: 'Long',
              display: true,
            }
          }],
          yAxes: [{
            type: 'linear',
            ticks: {
             
            },
            scaleLabel: {
              labelString: 'height',
              display: true
            }
          }]
        }
      }
    });
  }
}
